import { restClient } from '@/Core'

/**
 * Перехід задачі у «В роботі» (SPEC-003 §5.5, N6, `TASK_START`).
 * `POST /services/tasks/{uuid}/start` — тіло не потрібне.
 * Перенос легасі `Ship/Tasks/statusApiActions.js:handleStartAction` (PATCH-IRI → POST-uuid).
 */
export const StartTaskTask = async (uuid: string): Promise<void> => {
    await restClient.post(`/services/tasks/${uuid}/start`, { json: {} })
}
